import { loadingBarMiddleware } from "react-redux-loading-bar";
import { routerMiddleware } from "connected-react-router";
import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import promiseMiddleware from "redux-promise-middleware";
import { createTracker } from "redux-segment";
import thunkMiddleware from "redux-thunk";

import { DataStorage, errorMiddleware, history, loadingMiddleware, segmentTracks } from "utils";

import rootReducer from "./reducers";

const routeMiddleware = routerMiddleware(history);
const tracker = createTracker(segmentTracks);

export const defaultState = {
  currentUser: {
    id: 0,
    company: {
      id: 0,
      name: "",
      sizeUnit: "m2",
      statsUnit: "m2",
      industries: [],
      limitations: DataStorage.getCompanyLimitations(),
    },
    locale: "en",
    roleInCompany: "internal_user",
    dealColumns: [],
  },
  selectedPortfolioIDs: [],
  company: {
    logo: {
      photo: {
        src: "",
      },
    },
    locale: "en-GB",
    country: {},
    style: {},
    type: "leasing",
  },
  portfolios: [],
  portfolioNames: [],
  events: [],
  assetSort: { column: "updated_at", dir: "DESC" },
  asset: {
    id: 0,
    name: "",
    address: "",
    city: "",
    region: { id: 0, name: "" },
    contacts: [],
    portfolio: { id: 0, name: "", dealStages: {}, limitations: [] },
    pointPerson: {},
    company: { id: 0 },
    rentableArea: { value: 0, unit: "m2" },
    onMarket: { value: 0, unit: "m2" },
    owner: {},
    totalDemand: { value: 0, unit: "m2" },
    totalBrokerCompanies: 0,
    incentives: [],
    commissions: [],
    spaces: [],
    updatedAt: "",
    termsOfService: {},
  },
  deal: {
    id: 0,
    portfolioId: 0,
    name: "",
    status: "active",
    stage: "prospects",
    spaceCategories: [],
    shareStatus: "custom",
    assets: [],
    creator: { id: 0, company: { id: 0 } },
    pointPerson: {
      id: 0,
      fname: "",
      lname: "",
      company: { name: "" },
    },
    sharedBrokers: [],
    collaborators: [],
    portfolio: { id: 0, company: { id: 0, industries: [] } },
    spaces: [],
    size: {},
    budget: {},
    term: {},
  },
  dealModal: {
    parent: "Asset",
    selectedAssets: [],
    sharedBrokers: [],
    isShareModalOpen: false,
  },
  regions: [],
  flyer: {
    asset: {
      company: {},
      contacts: [],
      pointPerson: {},
      facilities: [],
      pictures: [],
      name: "",
      spaces: [],
    },
  },
  assetIncentives: [],
  incentives: [],
  integrations: [],
  isDealModalOpen: false,
  mails: [],
  tenant: {
    address: "",
    headCount: "",
    industry: "",
    leaseExpiration: "",
    name: "",
    rentableArea: { value: 0, unit: "m2" },
  },
  tenantContacts: [],
  spaces: [],
  channels: [],
  portfolioChannels: [],
  posts: [],
  proposals: [],
  dealsSortDir: "desc",
  dealsSortKey: "lastItem",
  assetLeadsSortDir: "desc",
  assetLeadsSortKey: "lastItem",
  proposal: {
    spaces: [],
  },
  deals: [],
  filteredDeals: [],
  notifications: [],
  assets: [],
  assetNames: [],
  loading: {},
  pointPersons: [],
  assetDigestSubscriptions: [],
  dealDigestSubscriptions: [],
  portfolioDealSubscriptions: [],
  companyUsers: [],
  termsOfServices: [],
  companies: [],
  companyAssets: [],
  modals: [],
  assetUsers: [],
  isFloorplanModalOpen: false,
  floorplans: [],
  floorplan: {},
  floorplanSpaces: [],
  clickedCoords: [],
  assetAttachments: [],
  assetPictures: [],
  assetLeads: [],
  filteredAssetLeads: [],
  assetDeals: [],
  contacts: [],
  dealStageAssets: [],
  assetLeadContacts: [],
  assetContacts: [],
};

const middleware = [
  thunkMiddleware,
  routeMiddleware,
  promiseMiddleware,
  errorMiddleware,
  loadingBarMiddleware(),
  loadingMiddleware,
  ...(process.env.NODE_ENV === "production" && !DataStorage.isImpersonating() ? [tracker] : []),
];

export default (preloadedState = defaultState) =>
  createStore(rootReducer, preloadedState, composeWithDevTools(applyMiddleware(...middleware)));
